import { render, staticRenderFns } from "./progressChart.vue?vue&type=template&id=2587a8fe&scoped=true&"
import script from "./progressChart.vue?vue&type=script&lang=js&"
export * from "./progressChart.vue?vue&type=script&lang=js&"
import style0 from "./progressChart.vue?vue&type=style&index=0&id=2587a8fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2587a8fe",
  null
  
)

export default component.exports